import { useState } from "react";
import "./index.css";

function ProjectsPage() {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: "My Portfolio",
      url: "https://www.rishikesh-janrao.site/",
      description: "Personal portfolio showcasing my work and skills",
      allowIframe: true,
    },
    {
      id: 2,
      title: "Avenue Corporation",
      url: "https://avenuecorporation.in",
      description: "Corporate website for Avenue Corporation",
      allowIframe: true,
    },
    {
      id: 3,
      title: "Octopus Industries",
      url: "https://octopusindustries.in",
      description: "Industrial solutions and services platform",
      allowIframe: true,
    },
    {
      id: 4,
      title: "Choice Goodwill",
      url: "https://choicegoodwill.com",
      description: "Goodwill services and community platform",
      allowIframe: true,
    },
    {
      id: 5,
      title: "Domino's Saudi Arabia",
      url: "https://www.dominos.sa/",
      description: "Domino's Pizza online ordering platform for Saudi Arabia",
      allowIframe: false,
    },
    {
      id: 6,
      title: "Domino's UAE",
      url: "https://www.dominos.ae",
      description: "Domino's Pizza online ordering platform for UAE",
      allowIframe: false,
    },
  ];

  const handleBack = () => {
    window.location.href = "/";
  };

  return (
    <div className="projects-page">
      <div className="projects-page__header">
        <button className="projects-page__back" onClick={handleBack}>
          <span className="projects-page__back-arrow">←</span>
          <span>Back to Home</span>
        </button>
        <h1>My Projects</h1>
        <p>Explore my live websites and applications</p>
      </div>

      <div className="projects-page__grid">
        {projects.map((project) => (
          <div
            key={project.id}
            className="project-card"
            onClick={() => project.allowIframe && setSelectedProject(project)}
            style={{ cursor: project.allowIframe ? 'pointer' : 'default' }}
          >
            <div className="project-card__preview">
              {project.allowIframe ? (
                <iframe
                  src={project.url}
                  title={project.title}
                  loading="lazy"
                  sandbox="allow-scripts allow-same-origin"
                  style={{ pointerEvents: 'none' }}
                />
              ) : (
                <div className="project-card__preview-overlay">
                  <h4>{project.title}</h4>
                  <p>Click "Visit Site" to view</p>
                </div>
              )}
            </div>
            <div className="project-card__info">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                Visit Site →
              </a>
            </div>
          </div>
        ))}
      </div>

      {selectedProject && (
        <div
          className="project-modal"
          onClick={() => setSelectedProject(null)}
        >
          <div className="project-modal__content" onClick={(e) => e.stopPropagation()}>
            <button
              className="project-modal__close"
              onClick={() => setSelectedProject(null)}
            >
              ×
            </button>
            <h2>{selectedProject.title}</h2>
            <div className="project-modal__iframe">
              <iframe
                src={selectedProject.url}
                title={selectedProject.title}
                sandbox="allow-scripts allow-same-origin allow-forms"
              />
            </div>
            <div className="project-modal__actions">
              <a
                href={selectedProject.url}
                target="_blank"
                rel="noopener noreferrer"
                className="project-modal__button"
              >
                Open in New Tab
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectsPage;
